import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { InsuranceFlowStatus } from 'src/app/_enums/insurance-flow/insurance-flow-status.enum';
import { AddProposalModalComponent } from 'src/app/shared/components/add-proposal-modal/add-proposal-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { BaseStepperAction } from '../base-action';

@Component({
  selector: 'app-update-lead-stepper-action',
  standalone: true,
  imports: [
    CommonModule,
    NgbTooltipModule,
    IconsModule,
    AddProposalModalComponent,
  ],
  templateUrl: './create-proposal.component.html',
})
export class CreateProposalStepperActionComponent extends BaseStepperAction {
  get enabled() {
    const status = this.state.insuranceFlowData?.status;
    return (
      status === InsuranceFlowStatus.PENDING_LEAD ||
      status === InsuranceFlowStatus.PREPARING_OFFERS
    );
  }

  get lead() {
    return this.state.lead;
  }
}
